export const colors = {
  blue: '#417DFA',
  white: '#fff',
  gray: '#E8E8E8',
  darkGray: '#A3A3A3',
  lightGray: '#F6F6F6',
  black: '#000',
  charcoal: '#4C4B4B',
  trueCobalt: '#042E87',
  aliceBlue: '#DFEAF6',
  neutralBluish600: '#555F74',
  neutralBluish500: '#707C94',
  info: {
    light: '#EBF1FE',
    dark: '#1D48A8',
  },
  success: {
    main: '#31B81C',
    background: '#E7F8E4',
    text: '#005C1A',
  },
  error: {
    main: '#D3302F',
    background: '#FBEAEA',
    text: '#A61F2D',
  },
};
